// External imports
import Image from "next/image";
import { useState } from "react";

// Local imports
import classes from "./style.module.css";

// Floating Onam festival button shown on desktop (malayalam only)
export default function FestivalButton() {
  const [isHidden, setIsHidden] = useState(false);

  if (isHidden) return null;

  return (
    <a
      className={`${classes.button}`}
      href="https://onam.manglish.app/?utm_source=web_editor"
      target="_blank"
      onClick={() => setIsHidden(true)}
    >
      <Image
        className={`${classes.flower}`}
        src="/flower.svg"
        width={30}
        height={30}
        alt=""
      />
    </a>
  );
}
